<template>
    <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
        <div class="card mb-g">
            <div class="card-body pb-0 px-4">
                <div class="border-top-0 border-left-0 border-right-0">
                    <h4 class="mb-0 flex-1 text-dark fw-500">
                        Quét căn cước công dân tự động
                    </h4>
                    <p class="text-gray-600 italic">
                        <i>Chụp ảnh cả hai mặt của căn cước để tự động điền đầy đủ thông tin</i>
                    </p>
                </div>

                <!-- Main Content -->
                <div class="row g-4 mt-3">
                    <!-- Phần tải ảnh - 6 cột -->
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <div class="bg-gray-100 rounded p-4">
                                <!-- Header với nút chuyển mặt -->
                                <div class="d-flex align-items-center justify-content-between mb-3">
                                    <h2 class="h5 fw-semibold d-flex align-items-center mb-0">
                                        <i class="fas fa-upload me-2 mr-1"></i>
                                        <label class="mt-2"> {{
                                                currentSide === 'front' ? 'Tải lên mặt trước' : 'Tải lên mặt sau'
                                            }} </label>
                                    </h2>
                                    <button
                                        @click="switchSide"
                                        disabled
                                        class="btn btn-outline-primary-custom btn-sm d-flex align-items-center"
                                    >
                                        <i class="fas fa-exchange-alt mr-2"></i>
                                        Chuyển mặt
                                    </button>
                                </div>

                                <!-- Thanh tiến trình -->
                                <div class="mb-3">
                                    <div
                                        class="d-flex align-items-center justify-content-between small text-muted mb-2">
                                        <span :class="{ 'text-success fw-medium': frontImage }"
                                              class="d-flex align-items-center">
                                            <i v-if="frontImage" data-lucide="check" class="me-1 icon-sm"></i>
                                            Mặt trước
                                        </span>
                                        <span :class="{ 'text-success fw-medium': backImage }"
                                              class="d-flex align-items-center">
                                            <i v-if="backImage" data-lucide="check" class="me-1 icon-sm"></i>
                                            Mặt sau
                                        </span>
                                    </div>
                                    <div class="progress progress-custom">
                                        <div
                                            class="progress-bar bg-primary transition-all"
                                            role="progressbar"
                                            :style="{ width: progressWidth + '%' }"
                                            :aria-valuenow="progressWidth"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    </div>
                                </div>
<!--                                @click="triggerFileUpload"-->
<!--                                @dragover.prevent="handleDragOver"-->
<!--                                @dragleave.prevent="handleDragLeave"-->
<!--                                @drop.prevent="handleDrop"-->
                                <!-- Image preview / Upload zone -->
                                <div
                                    class="image-preview d-flex align-items-center justify-content-center mb-3 position-relative upload-zone"
                                    :class="{ 'dragover': isDragOver }"

                                >
                                    <img
                                        v-if="getCurrentImage()"
                                        :src="getCurrentImage()"
                                        :alt="currentSide === 'front' ? 'Mặt trước căn cước' : 'Mặt sau căn cước'"
                                        class="img-fluid h-100 w-100"
                                        style="object-fit: contain;"
                                    />

                                    <div v-else class="text-center image-placeholder">
                                        <i class="fas fa-cloud-upload fa-4x mb-4"></i>
                                        <p>Tính năng tạm dừng, vui lòng nhập thông tin bên cạnh</p>
                                        <p class="fw-medium mb-2">
                                            {{
                                                currentSide === 'front' ? 'Tải lên mặt trước căn cước' : 'Tải lên mặt sau căn cước'
                                            }}
                                        </p>
                                        <p class="small mb-2 text-primary">
                                            Nhấp để chọn file hoặc kéo thả ảnh vào đây
                                        </p>
                                        <p class="small mb-0">
                                            {{
                                                currentSide === 'front'
                                                    ? 'Mặt có ảnh, họ tên, số CCCD, ngày sinh'
                                                    : 'Mặt có ngày cấp, có giá trị đến, cơ quan cấp'
                                            }}
                                        </p>
                                    </div>

                                    <!-- Loading overlay -->
                                    <transition name="fade">
                                        <div v-if="isScanning"
                                             class="position-absolute top-0 start-0 w-100 h-100 loading-overlay d-flex align-items-center justify-content-center">
                                            <div class="bg-white rounded p-3 d-flex align-items-center">
                                                <div class="spinner me-3"></div>
                                                <span class="text-primary fw-medium">
                                                    Đang xử lý {{
                                                        scanningStep === 'front' ? 'mặt trước' : 'mặt sau'
                                                    }}...
                                                </span>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition name="fade">
                                        <div v-if="isScanning"
                                             class="position-absolute top-0 start-0 w-100 h-100 loading-overlay d-flex align-items-center justify-content-center">
                                            <div class="bg-white rounded p-3 d-flex flex-column align-items-center">
                                                <div class="spinner mb-2"></div>
                                                <span class="text-primary fw-medium mb-2">
                Đang xử lý {{ scanningStep === 'front' ? 'mặt trước' : 'mặt sau' }}...
            </span>
                                                <!-- Thêm thanh tiến trình OCR -->
                                                <div class="progress w-100 mb-2" style="height: 6px;">
                                                    <div
                                                        class="progress-bar bg-primary"
                                                        :style="{ width: ocrProgress + '%' }"
                                                    ></div>
                                                </div>
                                                <small class="text-muted">{{ ocrProgress }}%</small>
                                            </div>
                                        </div>
                                    </transition>
                                </div>

                                <!-- Nút điều khiển -->
                                <div class="d-flex gap-2">
                                    <button
                                        @click="triggerFileUpload"
                                        disabled
                                        class="btn btn-primary flex-fill d-flex align-items-center justify-content-center mr-2"
                                    >
                                        <i class="fas fa-upload mr-1"></i>
                                        Chọn file {{ currentSide === 'front' ? 'mặt trước' : 'mặt sau' }}
                                    </button>

                                    <!--                                    <button-->
                                    <!--                                        @click="removeCurrentImage"-->
                                    <!--                                        v-if="getCurrentImage()"-->
                                    <!--                                        class="btn btn-outline-danger d-flex align-items-center justify-content-center"-->
                                    <!--                                    >-->
                                    <!--                                        <i data-lucide="trash-2" class="me-2 icon-sm"></i>-->
                                    <!--                                        Xóa-->
                                    <!--                                    </button>-->

                                    <button
                                        @click="resetForm"
                                        disabled
                                        class="btn btn-secondary d-flex align-items-center justify-content-center"
                                    >
                                        <i class="fas fa-undo"></i>
                                    </button>
                                </div>

                                <input
                                    ref="fileInput"
                                    type="file"
                                    accept="image/*"
                                    @change="handleFileUpload"
                                    class="d-none"
                                />
                            </div>

                            <!-- Hướng dẫn -->
                            <div class="alert border-info" style="background-color: rgb(239 246 255)">
                                <div class="d-flex align-items-start">
                                    <i class="far fa-info-circle mr-1 mt-1" style="color: #2196F3 !important"></i>
                                    <div class="text-info">
                                        <p class="fw-medium bold" style="font-size: 15px;">Hướng dẫn tải ảnh:</p>
                                        <ul class="large mb-0"
                                            style="list-style-type: disc; list-style-position: outside; padding-left: 0; margin-left: 10px;">
                                            <li class="mb-1"><strong class="bold">Mặt trước:</strong> Chứa ảnh, họ tên,
                                                số CCCD, ngày sinh, địa chỉ
                                            </li>
                                            <li class="mb-1"><strong class="bold">Mặt sau:</strong> Chứa ngày cấp, có
                                                giá trị đến, cơ quan cấp
                                            </li>
                                            <li class="mb-1"><strong class="bold">Định dạng:</strong> JPG, PNG, JPEG
                                                (tối đa 10MB)
                                            </li>
                                            <li><strong class="bold">Chất lượng:</strong> Ảnh rõ nét, không bị mờ hoặc
                                                nghiêng
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- Trạng thái xử lý -->
                            <transition name="slide">
                                <div v-if="(frontImage || backImage) && !isScanning"
                                     :class="[
                                         'alert border rounded p-3',
                                         (isFormComplete || isFormFull) ? 'alert-success border-success' : 'alert-warning border-warning'
                                     ]">
                                    <div :class="[
                                        'd-flex align-items-center',
                                        (isFormComplete || isFormFull) ? 'text-success' : 'text-warning'
                                    ]">
                                        <i class="fas fa-check mr-1"></i>
                                        <span class="fw-medium large bold">
                                            {{ (isFormComplete || isFormFull) ? 'Hoàn thành!' : 'Đang tiến hành...' }}
                                        </span>
                                    </div>
                                    <p :class="[
                                        'large mb-0 mt-1',
                                        (isFormComplete || isFormFull) ? 'text-success' : 'text-warning'
                                    ]">
                                        {{ getStatusMessage() }}
                                    </p>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div v-if="ocrError" class="alert alert-danger border-danger">
                                    <div class="d-flex align-items-center text-danger">
                                        <i class="fas fa-exclamation-triangle mr-2"></i>
                                        <span class="fw-medium">Lỗi xử lý ảnh</span>
                                    </div>
                                    <p class="mb-2 mt-1">{{ ocrError }}</p>
                                    <button @click="retryOCR" class="btn btn-sm btn-outline-danger">
                                        <i class="fas fa-redo mr-1"></i>
                                        Thử lại
                                    </button>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <!-- Form thông tin - 6 cột -->
                    <div class="col-lg-6 mb-5">
                        <div class="bg-gray-100 rounded p-4">
                            <h2 class="h5 fw-semibold mb-3 d-flex align-items-center">
                                <i class="fas fa-id-card mr-1" style="font-size: 20px"></i>
                                Thông tin căn cước
                            </h2>

                            <div class="mb-4">
                                <!-- Thông tin từ mặt trước -->
                                <div class="border-left-primary ps-3 mb-4">
                                    <h2 class="h6 fw-medium text-dark mb-1 ml-3">Thông tin mặt trước</h2>
                                    <div class="row g-3 ml-1">
                                        <div class="col-12">
                                            <label class="form-label fw-medium text-dark">
                                                <i class="fal fa-user"></i>
                                                Họ và tên
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Họ và tên"
                                                rules="required"
                                            >
                                                <input
                                                    type="text"
                                                    v-model="formData.full_name"
                                                    class="form-control mb-1"
                                                    placeholder="Nhập họ và tên"
                                                />
                                                <div class="text-danger small mb-2">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <label class="form-label fw-medium text-dark">
                                                Số CCCD
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Số CCCD"
                                                rules="required"
                                            >
                                                <input
                                                    type="text"
                                                    v-model="formData.id_number"
                                                    class="form-control mb-1"
                                                    placeholder="Số căn cước"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label fw-medium text-dark">
                                                <i data-lucide="calendar" class="me-1 icon-sm"></i>
                                                Ngày sinh
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Ngày sinh"
                                                rules="required"
                                            >
                                                <el-date-picker
                                                    v-model="formData.date_of_birth"
                                                    type="date"
                                                    placeholder="Ngày sinh"
                                                    format="dd/MM/yyyy"
                                                    value-format="yyyy-MM-dd"
                                                    style="width: 100%"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>

                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <label class="form-label fw-medium text-dark">
                                                Giới tính
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Giới tính"
                                                rules="required"
                                            >
                                                <el-select
                                                    v-model="formData.gender"
                                                    class="form-select"
                                                >
                                                    <el-option value="">Chọn giới tính</el-option>
                                                    <el-option value="Nam">Nam</el-option>
                                                    <el-option value="Nữ">Nữ</el-option>
                                                </el-select>
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label fw-medium text-dark">
                                                Quốc tịch
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Quốc tịch"
                                                rules="required"
                                            >
                                                <input
                                                    type="text"
                                                    v-model="formData.nationality"
                                                    class="form-control mb-1"
                                                    placeholder="Quốc tịch"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>

                                        <div class="col-12 mb-3">
                                            <label class="form-label fw-medium text-dark">
                                                Quê quán
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Quê quán"
                                                rules="required"
                                            >
                                                <textarea
                                                    v-model="formData.place_of_origin"
                                                    class="form-control mb-1"
                                                    rows="2"
                                                    placeholder="Quê quán"
                                                ></textarea>
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <label class="form-label fw-medium text-dark">
                                                Nơi thường trú
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Nơi thường trú"
                                                rules="required"
                                            >
                                                <textarea
                                                    v-model="formData.place_of_residence"
                                                    class="form-control mb-1"
                                                    rows="2"
                                                    placeholder="Địa chỉ thường trú"
                                                ></textarea>
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label fw-medium text-dark">
                                                Có giá trị đến
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Có giá trị đến"
                                                rules="required"
                                            >
                                                <el-date-picker
                                                    v-model="formData.expiry_date"
                                                    type="date"
                                                    placeholder="Giá trị đến"
                                                    format="dd/MM/yyyy"
                                                    value-format="yyyy-MM-dd"
                                                    style="width: 100%"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>

                                <!-- Thông tin từ mặt sau -->
                                <div class="border-left-success ps-3">
                                    <h3 class="h6 fw-medium text-dark mb-1 ml-3">Thông tin mặt sau</h3>

                                    <div class="row g-3 ml-2">
                                        <div class="col-12 mb-3">
                                            <label class="form-label fw-medium text-dark">
                                                Ngày cấp
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Ngày cấp"
                                                rules="required"
                                            >
                                                <el-date-picker
                                                    v-model="formData.issued_date"
                                                    type="date"
                                                    placeholder="Ngày cấp"
                                                    format="dd/MM/yyyy"
                                                    value-format="yyyy-MM-dd"
                                                    style="width: 100%"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-12">
                                            <label class="form-label fw-medium text-dark">
                                                Cơ quan cấp
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                name="Cơ quan cấp"
                                                rules="required"
                                            >
                                                <input
                                                    type="text"
                                                    v-model="formData.issued_place"
                                                    class="form-control mb-1"
                                                    placeholder="Cơ quan cấp căn cước"
                                                />
                                                <div class="text-danger small">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>

                                <!-- Cập nhật nút Save -->
                                <div class="d-flex gap-2">
                                    <button
                                        @click="handleSubmit(saveForm)"
                                        :disabled="invalid"
                                        :class="[
            'btn flex-fill mt-4 fw-medium',
            !invalid
                ? 'btn-primary'
                : 'btn-secondary'
        ]"
                                    >
                                        {{ !invalid ? 'Lưu thông tin' : 'Vui lòng nhập đầy đủ thông tin' }}
                                    </button>

                                    <button
                                        v-if="rawOcrText && !showRawText"
                                        @click="showRawText = true"
                                        class="btn btn-outline-info mt-4"
                                        title="Xem văn bản OCR gốc"
                                    >
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>

                                <div v-if="rawOcrText && showRawText" class="mt-3">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="fw-medium text-dark mb-0">Văn bản OCR gốc</h6>
                                        <button @click="showRawText = false" class="btn btn-sm btn-outline-secondary">
                                            <i class="fas fa-eye-slash"></i>
                                        </button>
                                    </div>
                                    <div class="bg-light p-3 rounded small"
                                         style="max-height: 150px; overflow-y: auto;">
                                        <pre class="mb-0">{{ rawOcrText }}</pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import Tesseract from "tesseract.js";
import {EXTRACT_TEXT_FORM_IMAGE, SAVE_IDENTITY_CARD_INFO} from "../../../core/services/store/profile.module";

export default {
    name: "InformationCard",
    props: {
        confirming: Boolean,
        isFormFull: Boolean,
        formData: Object
    },
    data() {
        return {
            frontImage: null,
            backImage: null,
            currentSide: 'front',
            isScanning: false,
            scanningStep: '',
            isDragOver: false,
            ocrProgress: 0,
            ocrError: null,
            rawOcrText: '',
            showRawText: false,
            files_prop: null,
        }
    },
    computed: {
        progressWidth() {
            return (this.frontImage ? 50 : 0) + (this.backImage ? 50 : 0);
        },
        isFormComplete() {
            return this.frontImage && this.backImage && this.formData.full_name && this.formData.issued_date;
        }
    },
    mounted() {
        if (typeof Tesseract !== 'undefined') {
            console.log('Tesseract.js đã sẵn sàng');
        } else {
            console.error('Tesseract.js chưa được tải');
            this.ocrError = 'Thư viện OCR chưa được tải. Vui lòng refresh trang.';
        }
    },
    updated() {

    },
    methods: {
        getCurrentImage() {
            return this.currentSide === 'front' ? this.frontImage : this.backImage;
        },

        switchSide() {
            this.currentSide = this.currentSide === 'front' ? 'back' : 'front';
        },
        async processFrontSide(type) {
            this.scanningStep = type ? 'front' : 'back';
            this.ocrProgress = 0;
            this.ocrError = null;

            const formData = new FormData();
            formData.append('image', this.files_prop);
            formData.append('type', type);

            this.$store.dispatch(EXTRACT_TEXT_FORM_IMAGE, formData).then((res) => {
                if (!type) {
                    this.formData.full_name = res.data.full_name
                    this.formData.id_number = res.data.id_number
                    this.formData.date_of_birth = res.data.date_of_birth
                    this.formData.gender = res.data.gender
                    this.formData.place_of_residence = res.data.place_of_residence
                    this.formData.expiry_date = res.data.expiry_date
                    this.formData.place_of_origin = res.data.place_of_origin
                    this.formData.nationality = res.data.nationality
                    return;
                }

                this.formData.issued_date = res.data.issued_date
                this.formData.issued_place = res.data.issued_place

            });


        },


        triggerFileUpload() {
            if (!this.isScanning) {
                this.$refs.fileInput.click();
            }
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.processFile(file);
            }
            // Reset input để có thể chọn cùng file lần nữa
            event.target.value = '';
            this.files_prop = file;

        },

        async retryOCR() {
            this.ocrError = null;
            const currentImage = this.getCurrentImage();
            if (currentImage) {
                if (this.currentSide === 'front') {
                    await this.processFrontSide(1);
                } else {
                    await this.processFrontSide(0);
                }
            }
        },

        processFile(file) {
            // Kiểm tra kích thước file (10MB)
            if (file.size > 10 * 1024 * 1024) {
                alert('File quá lớn! Vui lòng chọn file nhỏ hơn 10MB.');
                return;
            }

            // Kiểm tra định dạng file
            if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
                alert('Định dạng file không hỗ trợ! Vui lòng chọn file JPG, JPEG hoặc PNG.');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const imageData = e.target.result;

                if (this.currentSide === 'front') {
                    this.frontImage = imageData;
                    console.log("trong nay")
                    this.processFrontSide(0);
                } else {
                    this.backImage = imageData;
                    this.processFrontSide(1);
                }
            };
            reader.readAsDataURL(file);
        },

        handleDragOver(event) {
            this.isDragOver = true;
        },

        handleDragLeave(event) {
            this.isDragOver = false;
        },

        handleDrop(event) {
            console.log("ok")
            this.isDragOver = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.processFile(files[0]);
            }
        },

        removeCurrentImage() {
            if (this.currentSide === 'front') {
                this.frontImage = null;
                // Xóa dữ liệu mặt trước
                this.formData.full_name = '';
                this.formData.id_number = '';
                this.formData.date_of_birth = '';
                this.formData.gender = '';
                this.formData.nationality = '';
                this.formData.place_of_origin = '';
                this.formData.place_of_residence = '';
            } else {
                this.backImage = null;
                // Xóa dữ liệu mặt sau
                this.formData.issued_date = '';
                this.formData.expiry_date = '';
            }
        },

        resetForm() {
            this.frontImage = null;
            this.backImage = null;
            this.currentSide = 'front';
            this.ocrError = null; // Thêm dòng này
            this.rawOcrText = ''; // Thêm dòng này
            this.showRawText = false; // Thêm dòng này
            this.ocrProgress = 0; // Thêm dòng này
            this.formData = {
                full_name: '',
                id_number: '',
                date_of_birth: '',
                gender: '',
                nationality: '',
                place_of_origin: '',
                place_of_residence: '',
                issued_date: '',
                expiry_date: '',
            };
        },

        getStatusMessage() {
            if (this.isFormComplete) {
                return 'Đã tải lên thành công cả hai mặt căn cước';
            }

            let message = `Đã tải lên ${this.frontImage ? 'mặt trước' : ''}${this.frontImage && this.backImage ? ' và ' : ''}${this.backImage ? 'mặt sau' : ''}. `;

            if (!this.frontImage) message += 'Cần tải lên mặt trước. ';
            if (!this.backImage) message += 'Cần tải lên mặt sau.';

            return message;
        },

        saveForm() {
                this.$store.dispatch(SAVE_IDENTITY_CARD_INFO, this.formData).then((res) => {
                    this.$message.success('Thông tin đã được lưu thành công!');

                });
                this.$emit('form-saved', this.formData);
        },
    }
}
</script>

<style scoped>
/* Animations */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.slide-enter-active, .slide-leave-active {
    transition: transform 0.3s;
}

.slide-enter, .slide-leave-to {
    transform: translateY(-10px);
}

/* Loading spinner */
.spinner {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Image preview styles */
.image-preview {
    background-color: #e9ecef;
    height: 250px;
    border-radius: 0.5rem;
    position: relative;
    overflow: hidden;
    border: 2px dashed #6c757d;
    transition: border-color 0.3s ease;
}

/*.image-preview:hover {*/
/*    border-color: #0d6efd;*/
/*}*/

.image-preview.dragover {
    border-color: #0d6efd;
    background-color: #e7f1ff;
}

.image-placeholder {
    color: #6c757d;
    cursor: pointer;
}

/* Border styles */
.border-left-primary {
    border-left: 4px solid #0d6efd !important;
}

.border-left-success {
    border-left: 4px solid #198754 !important;
}

/* Button styles */
.btn-outline-primary-custom {
    color: #0d6efd;
    background-color: #e7f1ff;
    border-color: #b6d7ff;
}

/*.btn-outline-primary-custom:hover {*/
/*    color: #0a58ca;*/
/*    background-color: #cce7ff;*/
/*    border-color: #9ec5fe;*/
/*}*/

/* Progress bar */
.progress-custom {
    height: 8px;
    background-color: #e9ecef !important;
}

/* Loading overlay */
.loading-overlay {
    background-color: rgba(13, 110, 253, 0.2);
}

/* Icon sizes */
.icon-sm {
    width: 16px;
    height: 16px;
}

.icon-md {
    width: 20px;
    height: 20px;
}

.icon-lg {
    width: 48px;
    height: 48px;
}

/* Upload zone hover effect */
.upload-zone {
    transition: all 0.3s ease;
}

.upload-zone:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card,
.card-body {
    min-width: 0;
}

.bg-gray-100 {
    min-width: 0;
}

.form-select,
/deep/ .el-select,
/deep/ .el-date-editor {
    width: 100%;
}

pre {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

@media (max-width: 991.98px) {
    .image-preview {
        height: 220px;
    }
}

@media (max-width: 575.98px) {
    .card-body {
        padding-left: 12px !important;
        padding-right: 12px !important;
    }

    .bg-gray-100 {
        padding: 12px !important;
    }

    .image-preview {
        height: 180px;
    }

    .image-placeholder .fa-4x {
        font-size: 2rem;
    }

    .d-flex.gap-2,
    .d-flex.align-items-center.justify-content-between {
        flex-wrap: wrap;
        gap: 8px;
    }

    .d-flex.gap-2 .btn {
        width: 100%;
        margin-right: 0 !important;
        white-space: normal;
    }

    .border-left-primary,
    .border-left-success {
        padding-left: 10px !important;
    }

    .row.g-3 {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}
</style>
